import React from 'react';
import PropTypes from 'prop-types';

import SVGIcon from './svg-icon';
import DeviceTracker from './device-tracker';

import styled from 'styled-components';

/**
 * Modal provides a standardized template for displaying an Edlio modal
 *
 * Uniform Dependencies
 * @requires css:components/react/modals
 */
export default class Modal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      device: 'desktop',
      mouseDownTarget: null
    };

    this.handleKeypress = this.handleKeypress.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
  }

  componentDidMount() {
    const { visible } = this.props;

    /*
     * prevent listening to keydown events when modal is hidden
     * so hideCallback is not called every time ESCAPE key is pressed.
     */
    if (visible) {
      document.addEventListener('keydown', this.handleKeypress);
      document.addEventListener('mousedown', this.handleMouseDown);
    }

    this.updateBodyStyle();
  }

  componentDidUpdate(prevProps) {
    const { visible } = this.props;

    if (prevProps.visible !== visible) {
      document.removeEventListener('keydown', this.handleKeypress);
      document.removeEventListener('mousedown', this.handleMouseDown);

      if (visible) {
        document.addEventListener('keydown', this.handleKeypress);
        document.addEventListener('mousedown', this.handleMouseDown);
      }

      this.updateBodyStyle();
    }
  }

  componentWillUnmount() {
    // FIX: Avoid direct dom manipulation. Find alternate correct solution
    document.removeEventListener('keydown', this.handleKeypress);
    document.removeEventListener('mousedown', this.handleMouseDown);
    document.body.removeAttribute('style');
  }

  updateBodyStyle() {
    const { visible } = this.props;

    // FIX: Avoid direct dom manipulation. Find alternate correct solution
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }

  handleMouseDown(event) {
    this.setState({ mouseDownTarget: event.target });
  }

  handleOverlayClick(event) {
    // FIX: Don't use string refs
    /* eslint-disable-next-line react/no-string-refs */
    const { modal } = this.refs;
    const { hideCallback } = this.props;
    const { mouseDownTarget } = this.state;

    const clickStartedOnOverlay = mouseDownTarget === event.target;

    if (!modal.contains(event.target) && event.target !== modal && clickStartedOnOverlay) {
      hideCallback();
    }
  }

  handleKeypress(event) {
    const { hideCallback, handleTabClick } = this.props;

    // Listen for 'Escape' keypress
    if (event.keyCode === 27) {
      hideCallback();
    }

    // Listen for 'Tab' keypress
    if (event.keyCode === 9) {
      handleTabClick(event);
    }
  }

  render() {
    const {
      title,
      children,
      hideCallback,
      visible,
      width,
      height,
      closeButtonRef,
      overflow,
      headerProps,
      containerProps
    } = this.props;

    const { device } = this.state;

    const desktop = device === 'desktop';

    if (!visible) {
      return null;
    }

    return (
      <div
        className='edlio-overlay uniform-overlay'
        onClick={this.handleOverlayClick.bind(this)}
        style={{
          zIndex: '2000',
          width: !desktop ? '100%' : null,
          height: !desktop ? '100%' : null
        }}
      >
        <DeviceTracker onResize={(e) => this.setState({ device: e })} />

        <div
          className='edlio-modal uniform-modal'
          // eslint-disable-next-line react/no-string-refs
          ref='modal'
          style={{ width, height, overflow }}
        >
          <header {...headerProps}>
            <h1>{title}</h1>

            <CloseButtonContainer
              data-qa='close-modal'
              className='close'
              onClick={hideCallback}
              ref={closeButtonRef}
              tabIndex='0'
            >
              <SVGIcon name='times' />
            </CloseButtonContainer>
          </header>

          <div
            {...containerProps}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: 'column',
              height: '90%'
            }}
          >
            {children}
          </div>
        </div>
      </div>
    )
  }
}

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  hideCallback: PropTypes.func.isRequired,
  handleTabClick: PropTypes.func,
  title: PropTypes.string,
  visible: PropTypes.bool,
  height: PropTypes.string,
  width: PropTypes.string,
  closeButtonRef: PropTypes.any,
  overflow: PropTypes.string,
  headerProps: PropTypes.object,
  containerProps: PropTypes.object
};

Modal.defaultProps = {
  visible: true,
  handleTabClick: () => {}
};

const CloseButtonContainer = styled.div`
  cursor: pointer;
  
  :focus {
    background: #f4f4f4;
  }
`;



// WEBPACK FOOTER //
// ./src/main/webapps/common/react/components/modal.js